import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from '@/App'
import { authService, LoginRedirect } from '@/features/auth'
import '@/index.css'
import { MsalAppProvider } from '@/providers/msal-app-provider'

const REDIRECT_BRIDGE_PATH = '/login/redirect'

const rootElement = document.getElementById('root')!

const renderInitError = (message: string) => {
  createRoot(rootElement).render(
    <main className="flex min-h-screen items-center justify-center p-6">
      <p className="max-w-md text-center text-sm text-red-600" role="alert">
        {message}
      </p>
    </main>
  )
}

const bootstrap = async () => {
  // Don't wrap the redirect bridge in MsalProvider to prevent MSAL from consuming the auth response
  const isRedirectPage = window.location.pathname === REDIRECT_BRIDGE_PATH

  if (isRedirectPage) {
    createRoot(rootElement).render(
      <StrictMode>
        <LoginRedirect />
      </StrictMode>
    )
    return
  }

  try {
    await authService.initialize()
  } catch (error) {
    const message =
      error instanceof Error ? error.message : 'Failed to initialize MSAL.'
    renderInitError(message)
    return
  }

  createRoot(rootElement).render(
    <StrictMode>
      <MsalAppProvider>
        <App />
      </MsalAppProvider>
    </StrictMode>
  )
}

void bootstrap()
